<template>
  <div class="d-flex align-center" :class="color" style="border-radius: 20px">
    <v-btn class="mx-2" small :disabled="selectedIndex < 1" @click="selectPrevious" icon>
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>

    <v-menu transition="scale-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="px-1" text v-bind="attrs" v-on="on" width="80">{{ dateShort }}</v-btn>
      </template>

      <v-list class="scrollableDateList py-0">
        <v-list-item-group v-model="selectedIndex">
          <v-list-item @click="selectedIndex = i" v-for="(item, i) in availableDateIsoStringsSorted" :key="i">
            <v-list-item-title>{{ formatIsoDateStringAsLocaleShortDate(item) }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <v-btn class="mx-2" :disabled="!hasNext" small @click="selectNext" icon>
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';

export default {
  name: 'DateListPicker',
  props: {
    availableDateIsoStringsSorted: Array,
    value: Number,
    color: String,
  },
  mixins: [commonMixin, dateTimeMixin],

  data() {
    return {
      selectedIndex: this.value,
    };
  },
  computed: {
    dateShort() {
      let isoString = this.availableDateIsoStringsSorted[this.selectedIndex];
      return this.formatIsoDateStringAsLocaleShortDate(isoString);
    },
    hasNext() {
      return this.availableDateIsoStringsSorted.length - 1 > this.selectedIndex;
    },
  },
  methods: {
    selectPrevious() {
      this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
    },
    selectNext() {
      this.selectedIndex = Math.min(this.selectedIndex + 1, this.availableDateIsoStringsSorted.length - 1);
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.selectedIndex = newValue;
    },
    selectedIndex(newValue, oldValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style>
.scrollableDateList {
  max-height: calc(100vh - 24px);
  overflow-y: auto;
}
</style>
